module.exports = __webpack_public_path__ + "img/8.9ca7d27c.jpg";